import CueManagerComponent from './cueManager.component';

export const cueManagerModule = {
	name: 'cueManagerComponent',
};

export default angular
	.module(cueManagerModule.name, [])
	.component('cueManager', new CueManagerComponent()).name;
